<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';
  import { tabbable } from 'tabbable';
  import throttle from 'lodash/throttle';
  
  export default {

    props: {
      focusContainerSelector: {
        type: String,
        default: '#main',
      },
      visibilityThreshold: {
        type: String,
        default: "1000",
      },
    },

    data() {
      return {
        show: false,
        tabbableContainer: null,
        bottomOffset: '2.4rem',
        spacing: {
          desktop: '4.8rem',
          mobile: '2.4rem',
        }
      };
    },

    computed: {
      buttonContent() {
        return addSvgToEnd("Back to top", "$typography/size:medium typography", "icon__arrow--16--stroke.svg", "typography/icon:after:270deg");
      },
    },

    mounted() {
      this.accountForPresenceOfGuideBanner();
      this.tabbableContainer = tabbable(document.querySelector(this.focusContainerSelector));
      this.throttledHandleScroll = throttle(this.handleScroll, 200);
      window.addEventListener('scroll', this.throttledHandleScroll);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.throttledHandleScroll);
    },

    methods: {
      handleScroll() {
        this.show = window.scrollY > this.visibilityThreshold;
      },
      handleClick() {
        this.tabbableContainer[0].focus();
      },
      updateBottomOffset() {
        const guideBanner = document.querySelector('[data-guide-banner]');
        let buttonBottomOffset = 2.4;
        if (guideBanner) {
          buttonBottomOffset = buttonBottomOffset + (guideBanner.offsetHeight / 10);
        }
        this.bottomOffset = `${buttonBottomOffset}rem`;
      },
      accountForPresenceOfGuideBanner() {
        const guideBanner = document.querySelector('[data-guide-banner]');
        if (guideBanner) {
          const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.contentRect.height >= 0) {
                this.updateBottomOffset();
              }
            });
          });

          resizeObserver.observe(guideBanner);
          this.updateBottomOffset();
        }
      },
    },
  };
</script>

<template>
  <Transition name="fade">
    <button
      v-show="show"
      :style="{
        '--768--layout--right': spacing.desktop,
        '--layout--right': spacing.mobile,
        bottom: bottomOffset,
        position: 'fixed'
      }"

      class="
        @768/layout/right
        layout/right
        link/focus
      "
      @click.prevent="handleClick"
      >
      <div
        style="
          --768--layout--padding--left: 1.6rem;
          --768--layout--padding--right: 1.6rem;
        "
        class="
          @768/layout/padding:left
          @768/layout/padding:right
          $color/background:white
          color/background
          layout/border:3pt
          layout/padding:bottom:page:0.5
          layout/padding:left:page:0.5
          layout/padding:right:page:0.5
          layout/padding:top:page:0.5
        "
        v-html="buttonContent"
      />
    </button>
  </Transition>
</template>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>